"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommunityPoolStatsToJSON = exports.CommunityPoolStatsFromJSONTyped = exports.CommunityPoolStatsFromJSON = void 0;
var runtime_1 = require("../runtime");
function CommunityPoolStatsFromJSON(json) {
    return CommunityPoolStatsFromJSONTyped(json, false);
}
exports.CommunityPoolStatsFromJSON = CommunityPoolStatsFromJSON;
function CommunityPoolStatsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'totalParticipants': !(0, runtime_1.exists)(json, 'totalParticipants') ? undefined : json['totalParticipants'],
        'totalInvited': !(0, runtime_1.exists)(json, 'totalInvited') ? undefined : json['totalInvited'],
        'totalJoined': !(0, runtime_1.exists)(json, 'totalJoined') ? undefined : json['totalJoined'],
        'totalRevoked': !(0, runtime_1.exists)(json, 'totalRevoked') ? undefined : json['totalRevoked'],
        'totalCreditsUsd': !(0, runtime_1.exists)(json, 'totalCreditsUsd') ? undefined : json['totalCreditsUsd'],
        'pendingAttestations': !(0, runtime_1.exists)(json, 'pendingAttestations') ? undefined : json['pendingAttestations'],
        'eligibleUsers': !(0, runtime_1.exists)(json, 'eligibleUsers') ? undefined : json['eligibleUsers'],
    };
}
exports.CommunityPoolStatsFromJSONTyped = CommunityPoolStatsFromJSONTyped;
function CommunityPoolStatsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'totalParticipants': value.totalParticipants,
        'totalInvited': value.totalInvited,
        'totalJoined': value.totalJoined,
        'totalRevoked': value.totalRevoked,
        'totalCreditsUsd': value.totalCreditsUsd,
        'pendingAttestations': value.pendingAttestations,
        'eligibleUsers': value.eligibleUsers,
    };
}
exports.CommunityPoolStatsToJSON = CommunityPoolStatsToJSON;
